import React from 'react';
import PropTypes from 'prop-types';
import { ADD_APPLE_ACCOUNT_ERROR_MODAL } from '~/Config/Modals';
import Modal from '~/Containers/Global/Modal/Modal';
import './AddAppleAccountErrorModal.scss';

function AddAppleAccountErrorModal({ modalId }) {
  return (
    <Modal id={modalId} overlayClassName="add-apple-account-error-modal" showCloseButton>
      <div className="add-apple-account-error-content">
        <h3>Oops!</h3>
        <p>
          It looks like you didn&apos;t enter a valid{' '}
          <a
            className="apple-instructions"
            target="_blank"
            href="https://support.apple.com/en-us/102654#generate"
          >
            <strong>app specific password</strong>
          </a>
          . This password is different than your iCloud password.
        </p>
        <p>
          <a
            className="apple-instructions"
            target="_blank"
            href="https://support.apple.com/en-us/102654#generate"
          >
            <strong>TAP HERE</strong>
          </a>{' '}
          to generate one.
        </p>
      </div>
    </Modal>
  );
}

AddAppleAccountErrorModal.propTypes = {
  modalId: PropTypes.string.isRequired,
};

AddAppleAccountErrorModal.defaultProps = {
  modalId: ADD_APPLE_ACCOUNT_ERROR_MODAL,
};

export default AddAppleAccountErrorModal;
